import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import '../../App.css';
import { useAuth } from '../../contexts/AuthContext';
import Calendar from '../../components/Calendar/Calendar';
import { CalendarProvider, useCalendar } from '../../contexts/CalendarContext';
import { bookingService } from '../../api/apiService';
import 'moment/locale/de';  // or any locale that uses day-month-year format
import DeletedOrdersList from './DeletedOrdersList';
import "../../styles/NewCalendar.css";

/**
 * DeletedOrdersPage component using the custom Calendar component
 * This component displays deleted orders in a calendar view using the API
 */
const DeletedOrdersPageContent = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState('list');
  const [deletedEvents, setDeletedEvents] = useState([]);
  const { events } = useCalendar();

  // Initial filters state with "canceled,deleted" preselected
  const initialFilters = {
    bookingStatus: 'canceled,deleted'
  };

  // Fetch deleted bookings on component mount
  useEffect(() => {
    const fetchDeletedBookings = async () => {
      setIsLoading(true);
      try {
        console.log('Fetching canceled and deleted bookings from 2 months ago and future...');
        
        // Calculate date range: from 2 months ago to far future
        const fromDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
        const toDate = moment().add(2, 'years').format('YYYY-MM-DD'); // Far future date
        
        console.log(`Fetching canceled and deleted bookings from ${fromDate} to ${toDate}`);
        
        // Fetch bookings with "canceled" and "deleted" status from 2 months ago and future
        const response = await bookingService.getAllBookings(
          1,        // page
          10000,    // limit - increased to ensure we get all orders
          fromDate, // from 2 months ago
          toDate,   // to far future
          'canceled,deleted', // only canceled and deleted orders
          null      // don't exclude anything since we specifically want canceled and deleted
        );

        if (response && response.data && response.data.bookings) {
          console.log(`Fetched ${response.data.bookings.length} canceled and deleted orders`);
          
          // Format the events similar to other pages
          const formattedEvents = response.data.bookings.map(booking => ({
            id: booking.id,
            title: booking.title || booking.boktitle || 'Untitled Booking',
            start: booking.start_date || booking.start,
            end: booking.end_date || booking.end,
            status: booking.status,
            client: booking.client,
            position: booking.position,
            set: booking.set,
            location: booking.location,
            location_name: booking.location_name,
            location_city: booking.location_city,
            location_short: booking.location_short,
            studio: booking.studio,
            kpi: booking.kpi,
            talent: booking.talent_name || booking.talent,
            range: booking.range,
            created_at: booking.created_at,
            created_by: booking.created_by,
            proposed_by: booking.proposed_by,
            proposedBy: booking.proposedBy,
            processing_by: booking.processing_by,
            group: booking.group,
            groupColor: booking.group_color || booking.groupColor,
            SonstigeInfo: booking.sonstige_info || booking.SonstigeInfo,
            startTime: booking.start_time,
            endTime: booking.end_time,
            createdAt: booking.createdAt,
            boktitle: booking.boktitle,
            company: booking.company
          }));
          
          setDeletedEvents(formattedEvents);
        } else {
          console.log('No canceled or deleted bookings found');
          setDeletedEvents([]);
        }
      } catch (error) {
        console.error('Error fetching canceled and deleted bookings:', error);
        setDeletedEvents([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDeletedBookings();
  }, []);

  // Handle event click
  const handleEventClick = (event) => {
    if (event && event.id) {
      navigate(`detail?id=${event.id}`);
    }
  };

  // Switch between calendar and list views
  const switchView = (viewType) => {
    setView(viewType);
  };

        return (
          <div className="content-wrapper page">
      <div className='content-wrapper'>
        <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '60px' }}>
                <h1>Canceled & Deleted Orders</h1>
            <div>
              <button 
                className={view === 'calendar' ? 'big-button' : 'big-button-active'} 
                onClick={() => switchView('list')} 
                style={{ marginLeft: 'auto' }}>
                List View
              </button>

                </div>
              </div>
                        
          {isLoading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
          ) : view === 'calendar' ? (
                        <Calendar
              onEventClick={handleEventClick}
              initialFilters={initialFilters}
              disableStatusFilter={true} // Optional: prevent users from changing the status filter
            />
          ) : (
            <DeletedOrdersList 
              events={deletedEvents}
            />
          )}
                    </div>
            </div>
          </div>
        );
};

// Wrap the component with CalendarProvider to make context available
const DeletedOrdersPage = () => (
  <CalendarProvider>
    <DeletedOrdersPageContent />
  </CalendarProvider>
);

export default DeletedOrdersPage;
